import { useTranslation } from '../../hooks/useTranslation'
import Money from '../../design/Money'
import Moment, { MomentHeadline, MomentIcon } from './Moment'

/** The payment went through. Replaces the QR or the amount to pay, so the
 *  customer is never left looking at a code that is already paid. The strip
 *  under the logo already says thank you. */
export default function ApprovedMoment({ amount, currency }: { amount: number; currency: string }) {
  const { t } = useTranslation()

  return (
    <Moment>
      <MomentIcon tone="trust">✓</MomentIcon>
      <MomentHeadline>{t('payment-approved')}</MomentHeadline>
      <div className="mt-cfd-3 whitespace-nowrap font-volte-semibold text-cfd-hero text-primary">
        <Money amount={amount} currency={currency} lead />
      </div>
    </Moment>
  )
}
